module.exports = __webpack_public_path__ + "img/4b83a5ec2211dc399ad3cb42092e9cac.svg";